export const NAME = 'mea';

export const REQUEST_MEAS = 'REQUEST_MEAS';
export const RECEIVE_MEAS = 'RECEIVE_MEAS';
export const FAILURE_MEAS = 'FAILURE_MEAS';

export const SELECTION_MOMENT_MEA_TYPE = 2;
export const FICHE_MARCHAND = 4;
export const FICHE_MARCHAND_OFFLINE = 68;
export const CAROUSEL_MEA_TYPE = 10;
export const ONLINE_OFFER = 14;
export const OFFLINE_OFFER = 63;
export const EBON_OFFER = 80;
export const BANDEAU_RUBRIQUE = 41;
export const BANNIERE_ANIMATION = 49;
export const BOOSTED_OFFER_MEA_TYPE = 60;
export const CATEGORY_OFFER_MEA_TYPE = 97;

// Sections MEA de la home (offres du moment + catégories) en carousel sur
// desktop (comme en mobile) ; false = grille statique de 4 blocs
export const HOME_MEA_SECTIONS_CAROUSEL_DESKTOP = true;

// MEA completion constants
export const TARGET_ONLINE_OFFERS = 4;
export const TARGET_OFFLINE_OFFERS = 4;
export const TARGET_EBON_OFFERS = 4;
export const TARGET_CATEGORY_OFFERS = 4;
export const TARGET_MOMENT_OFFERS = 4;
// Cible de complétion des sections rendues en carousel (mobile, et desktop
// quand HOME_MEA_SECTIONS_CAROUSEL_DESKTOP est actif) au lieu des 4 en grille
export const TARGET_CAROUSEL_OFFERS = 8;
export const DEFAULT_TURNOVER_ORDER = 999999;



// WEBPACK FOOTER //
// ./src/services/mea/constants.js